import DownloadIcon from '@mui/icons-material/Download'
import SendIcon from '@mui/icons-material/Send'
import VisibilityIcon from '@mui/icons-material/Visibility'
import { FC, memo } from 'react'
import {
  RecentFilesConStyles,
  RecentFilesContainerStyles,
  RecentFilesContentStyles,
  RecentFilesDownloadStyles,
  RecentFilesHeaderStyles,
  RecentFilesIconStyles,
  RecentFilesImageContainerStyles,
  RecentFilesNoFileStyles,
  RecentFilesOtherTitleStyles,
  RecentFilesSelectStyles,
  RecentFilesStyles,
  RecentFilesSubTitleStyles,
  RecentFilesTitleConStyles,
  RecentFilesTitleStyles,
  RecentFilesTopContainerStyles,
} from './RecentFiles.styles'

const RecentFiles: FC<RecentFilesProps> = memo(
  ({
    title = 'Related Files',
    files,
    options,
    showFilter = false,
  }: RecentFilesProps) => {
    return (
      <RecentFilesConStyles>
        <RecentFilesTopContainerStyles>
          <RecentFilesHeaderStyles>{title}</RecentFilesHeaderStyles>
          {showFilter && (
            <RecentFilesSelectStyles>
              {options?.map((option, index) => (
                <option key={index}>{option}</option>
              ))}
            </RecentFilesSelectStyles>
          )}
        </RecentFilesTopContainerStyles>

        {files?.length > 0 ? (
          <>
            {files?.map(
              (
                { title, fileName, dateTime, downloadUrl, sendUrl, viewUrl },
                index,
              ) => (
                <RecentFilesContainerStyles key={index}>
                  {title && (
                    <RecentFilesTitleStyles>{title}</RecentFilesTitleStyles>
                  )}
                  <RecentFilesStyles>
                    <RecentFilesContentStyles>
                      <RecentFilesImageContainerStyles></RecentFilesImageContainerStyles>
                      <RecentFilesTitleConStyles>
                        <RecentFilesSubTitleStyles>
                          {fileName}
                        </RecentFilesSubTitleStyles>
                        <RecentFilesOtherTitleStyles>
                          {dateTime}
                        </RecentFilesOtherTitleStyles>
                      </RecentFilesTitleConStyles>
                    </RecentFilesContentStyles>
                    <RecentFilesContentStyles>
                      {downloadUrl && (
                        <RecentFilesDownloadStyles href={downloadUrl} download>
                          <DownloadIcon style={{ width: '14px' }} />
                        </RecentFilesDownloadStyles>
                      )}
                      {sendUrl && (
                        <RecentFilesIconStyles>
                          <VisibilityIcon style={{ width: '14px' }} />
                        </RecentFilesIconStyles>
                      )}
                      {viewUrl && (
                        <RecentFilesIconStyles>
                          <SendIcon style={{ width: '14px' }} />
                        </RecentFilesIconStyles>
                      )}
                    </RecentFilesContentStyles>
                  </RecentFilesStyles>
                </RecentFilesContainerStyles>
              ),
            )}
          </>
        ) : (
          <RecentFilesNoFileStyles>No {title}</RecentFilesNoFileStyles>
        )}
      </RecentFilesConStyles>
    )
  },
)

export default RecentFiles
